
export enum FunctionalReviewResponseItemPriority {
  None = 0,
  P2 = 2,
  P3,
  P4
}
